module.exports = __webpack_public_path__ + "media/images/logos_siwf_big-d65101fbb71f49b7848481db5437d97c.jpg";